/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Faq_DescriptionInputs */

const en_meta_faq_description = /** @type {(inputs: Meta_Faq_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answers about AI automation projects: custom AI agents, RAG knowledge bases, n8n, integrating AI into existing software, cost, human review and data access.`)
};

const lv_meta_faq_description = /** @type {(inputs: Meta_Faq_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atbildes par AI automatizācijas projektiem: AI aģentu izstrāde, RAG zināšanu bāzes, n8n, AI integrācija esošajā programmatūrā, izmaksas un cilvēka pārbaude.`)
};

/**
* | output |
* | --- |
* | "Answers about AI automation projects: custom AI agents, RAG knowledge bases, n8n, integrating AI into existing software, cost, human review and data access." |
*
* @param {Meta_Faq_DescriptionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_faq_description = /** @type {((inputs?: Meta_Faq_DescriptionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Faq_DescriptionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_faq_description(inputs)
	return en_meta_faq_description(inputs)
});